var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-wrapper"},_vm._l((_vm.stepList),function(item,index){return _c('ImportStepItem',{key:index,attrs:{"index":index + 1,"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }